const validatePlzs = (plzs) => {
    const regex = /[0-9]{4}$/;
    return plzs ? regex.test(plzs.join(", ")) : true;
}

  export default validatePlzs;